export default "__VITE_ASSET__1c4d8269__"